import { Sandwich } from "lucide-react";

export const Loader = ({ label = "Loading…" }) => (
  <div
    data-testid="app-loader"
    className="min-h-[60vh] flex flex-col items-center justify-center gap-4 text-emerald-600"
  >
    <div className="animate-bounce">
      <Sandwich size={48} strokeWidth={2.2} />
    </div>
    <p className="font-display font-semibold text-lg">{label}</p>
  </div>
);
